import { connectedStore } from '../../store';
import deviceModes from '../constants/device-modes';
import selectors from '../selectors';

const DEVICE_MODE_TO_BREAKPOINT = {
  [deviceModes.DESKTOP]: '',
  [deviceModes.TABLET]: 'max-xl',
  [deviceModes.MOBILE]: 'max-md',
};

const getBreakpointByDeviceMode = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const deviceMode = selectors.getDeviceMode(state);

  return DEVICE_MODE_TO_BREAKPOINT[deviceMode];
};

export default getBreakpointByDeviceMode;
